import { fg } from '@atlassian/jira-feature-gating';
import messages from './messages.tsx';

export const getIssueLimitMessages = (routeName: string) => {
	switch (routeName) {
		case 'rapidboard-board':
		case 'rapidboard-user-board':
		case 'software-boards':
		case 'servicedesk-boards':
			return {
				headerMessage: fg('jira-issue-terminology-update-m4')
					? messages.boardHeaderIssueTerminologyRefreshM4
					: messages.boardHeader,
				descriptionMessage: fg('jira-issue-terminology-update-m4')
					? messages.boardDescriptionIssueTerminologyRefreshM4
					: messages.boardDescription,
			};

		case 'software-timeline':
		case 'software-timeline-classic':
			return {
				headerMessage: fg('jira-issue-terminology-update-m4')
					? messages.timelineHeaderIssueTerminologyRefreshM4
					: messages.timelineHeader,
				descriptionMessage: fg('jira-issue-terminology-update-m4')
					? messages.timelineDescriptionIssueTerminologyRefreshM4
					: messages.timelineDescription,
			};
		case 'rapidboard-backlog':
		case 'rapidboard-user-backlog':
		case 'software-backlog':
		default:
			return {
				headerMessage: fg('jira-issue-terminology-update-m4')
					? messages.backlogHeaderIssueTerminologyRefreshM4
					: messages.backlogHeader,
				descriptionMessage: fg('jira-issue-terminology-update-m4')
					? messages.backlogDescriptionIssueTerminologyRefreshM4
					: messages.backlogDescription,
			};
	}
};
